import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { Skeleton } from "@/components/ui/skeleton";

export const AdminRouteGuard = () => {
  const { isLoading, user } = useAuth();

  if ( isLoading ) {
    return (
      <div className="p-6">
        <Skeleton className="h-16 w-full mb-4" />
        <div className="grid grid-cols-4 gap-4">
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
        </div>
      </div>
    );
  }

  // Se o usuário não estiver logado, o Outlet renderizará o ProtectedPage,
  // que então cuidará do redirecionamento para o login.
  // Este guarda deve se preocupar apenas com a role de um usuário autenticado.
  if ( !user ) {
    return <Outlet />;
  }

  // O 'role' vem de uma claim específica do OIDC/Azure AD.
  const role = user.profile?.[ "http://schemas.microsoft.com/ws/2008/06/identity/claims/role" ];

  // Verifica se a role é 'Administrator'.
  if ( role === 'Administrator' ) {
    return <Outlet />;
  }

  // Se o usuário estiver logado, mas não for um administrador, redirecione-o.
  console.log( 'Acesso negado para rota administrativa. Redirecionando.' );
  return <Navigate to="/" replace />;
};